import React from "react";

type DeleteModalProps = {
  onCancel: () => void;
  onConfirm: () => void;
};

export const DeleteModal: React.FC<DeleteModalProps> = ({
  onCancel,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm mx-4 text-center">
        <h4 className="text-lg font-semibold mb-2 ">Confirmar eliminación</h4>
        <p className="text-gray-600 mb-4">
          ¿Estás seguro de eliminar este registro?
        </p>
        <p className="text-red-600 mb-4">Esta acción no se puede deshacer.</p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
  );
};
